module.exports = __webpack_public_path__ + "img/home-1-INTsmall.5d3ede1d.png";